<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.572"
      height="20.18"
      viewBox="0 0 20.572 20.18"
      class="scaling-svg"
    >
      <g id="Group_98" data-name="Group 98" transform="translate(-52.003 -545)">
        <g id="Icon_mail" transform="translate(62.707 544.614)">
          <path
            id="Shape"
            d="M9,7H1A1,1,0,0,1,0,6V1A1,1,0,0,1,1,0H9a1,1,0,0,1,1,1V6A1,1,0,0,1,9,7ZM1,1.589V5.5a.5.5,0,0,0,.5.5h7A.5.5,0,0,0,9,5.5V1.589l-4,2.5ZM1.944,1,5,2.911,8.057,1Z"
            transform="translate(-0.133 0.386)"
            fill="#534d69"
          />
        </g>
        <g id="Group_95" data-name="Group 95" transform="translate(0.003 338.68)">
          <g id="Icon_blank" transform="translate(52 211.5)">
            <g id="Icon_blank-2" data-name="Icon_blank">
              <path
                id="Shape-2"
                data-name="Shape"
                d="M10.5,15h-9A1.5,1.5,0,0,1,0,13.5V1.5A1.5,1.5,0,0,1,1.5,0H9l3,3V13.5A1.5,1.5,0,0,1,10.5,15ZM2.25,1.5a.751.751,0,0,0-.75.75v10.5a.751.751,0,0,0,.75.75h7.5a.751.751,0,0,0,.751-.75V4.5h-3v-3ZM9,1.5V3h1.5Z"
                fill="#534d69"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class OneMailWithAttachmentIcon extends Vue {}
</script>

<style>
</style>
